<div class="content container-fluid">
  <div class="row">
    <div class="page-header pb-0 mb-0">
        <div class="col-sm-12 text-start">
          <h4 *ngIf="user()" class="page-title text-start">{{"dashboard.welcome" | translate}}!</h4>
          <h3 class="page-title text-start pt-2">{{ (title() + '.title') | translate}}</h3>
        </div>
    </div>
  </div>
</div>
